/* istanbul ignore file */
export const formatDate = (input: string | null | undefined): string => {
  if (!input) return "";
  const date = new Date(input);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("nl-NL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const formatCurrency = (
  input: any | null | undefined,
  nillChar = "",
  minimumFractionDigits = 0,
  maximumFractionDigits = 0
): string => {
  if (input === null) return nillChar;
  if (input === undefined) return nillChar;
  if (input.length <= 0) return input;
  if (isNaN(input)) return input;

  return new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  }).format(Number(input));
};

export const formatCurrencyWithDecimals = (
  input: number | null | undefined
): string => {
  if (!input) return "";

  return formatCurrency(input, "", 2, 2);
};

export const formatPercentage = (
  input: number | null | undefined,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
): string => {
  if (!input) return "";

  // Check if input has decimal part
  const hasDecimals = input % 1 !== 0;

  return new Intl.NumberFormat("nl-NL", {
    style: "percent",
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).format(Number(input) / 100);
};

export const formatPercentageFractionDigits = (
  input: number | null | undefined,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2
): string => {
  if (!input) return "";

  return new Intl.NumberFormat("nl-NL", {
    style: "percent",
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  }).format(Number(input) / 100);
};
export const formatDuration = (
  looptijdInMaanden: number | null | undefined
): string => {
  if (typeof looptijdInMaanden !== "number" || looptijdInMaanden < 0) return "";

  if (looptijdInMaanden === 0) {
    return "(0 maanden)";
  }

  const maanden = looptijdInMaanden;
  if (maanden >= 12) {
    const jaren = Math.floor(maanden / 12);
    const resterendeMaanden = maanden % 12;
    const jarenText = `${jaren} ${jaren === 1 ? "jaar" : "jaren"}`;

    if (resterendeMaanden > 0) {
      const maandenText = `${resterendeMaanden} ${
        resterendeMaanden === 1 ? "maand" : "maanden"
      }`;
      return `${jarenText}, ${maandenText}`;
    }
    return `${jarenText}`;
  }
  // maanden < 12 and > 0
  return `${maanden} ${maanden === 1 ? "maand" : "maanden"}`;
};
